import { PLFlag, GBFlag } from 'mantine-flagpack';
import { pl, enGB } from 'date-fns/locale';

const LANGUAGES = {
	PL: {
		name: 'Polski',
		code: 'pl',
		displayCode: 'PL',
		flag: PLFlag,
		dateFnsLocale: pl,
	},
	EN: {
		name: 'English',
		code: 'en',
		displayCode: 'EN',
		flag: GBFlag,
		dateFnsLocale: enGB,
	},
} as const;

export default LANGUAGES;
